var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('promoIconButton',{attrs:{"isCount":_vm.isCount,"leftCounter":_vm.leftCounter,"styleCount":_vm.styleCount,"type":'freeBets'}})
}
var staticRenderFns = []

export { render, staticRenderFns }